import ListIncreaseSalaryRequests from './views/List.vue'
import CreateIncreaseSalaryRequest from './views/Create.vue'

export const IncreaseSalaryRequestsRoutes = [
  {
    path: '/increase-salary-requests',
    name: 'ListIncreaseSalaryRequests',
    component: ListIncreaseSalaryRequests,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'increase_salary_request:list'
    }
  },
  {
    path: '/increase-salary-request',
    name: 'CreateIncreaseSalaryRequest',
    component: CreateIncreaseSalaryRequest,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'increase_salary_request:bulk'
    }
  }
]
